import Store from '@/store';
import SlsEsPrioriClient from '@/api/SistemaDKP/sls-es-priori.client';
import { ErrorMessage } from '@/libs/Error';

export default class SLSEsPrioriService {
  constructor() {
    this.client = new SlsEsPrioriClient();
    this.error = new ErrorMessage();
    this.store = Store;
  }

  async selectPrioridadePedido() {
    this.store.commit('SLSEsPriori/SET_LOADING', true);
    try {
      const { data, ...pagination } = await this.client.selectPrioridadePedido();
      this.store.commit('SLSEsPriori/SET_PRIORIDADES_PEDIDO', data);
      this.store.commit('SLSEsPriori/SET_FILTERS', pagination);
      return data;
    } catch (error) {
      this.error.message(error, 'Erro ao listar os items');
    } finally {
      this.store.commit('SLSEsPriori/SET_LOADING', false);
    }
  }
}
